import { motion } from 'framer-motion';
import styled from 'styled-components';

const spring = {
  type: 'spring',
  stiffness: 700,
  damping: 30,
};

interface OnOffButtonProps {
  isOn: boolean;
  toggleSwitch: () => void;
}

export const OnOffButton = ({ isOn, toggleSwitch }: OnOffButtonProps) => {
  return (
    <Wrap>
      <div className="switch" data-ison={isOn} onClick={toggleSwitch}>
        <motion.div className="handle" layout transition={spring} />
      </div>
    </Wrap>
  );
};

// style
const Wrap = styled.div`
  .switch {
    width: 4.6rem;
    height: 2.8rem;
    background-color: ${(props) => props.theme.inputOffBgColor};
    display: flex;
    justify-content: flex-start;
    border-radius: 5rem;
    padding: 0.3rem;
    cursor: pointer;
  }

  .switch[data-ison='true'] {
    justify-content: flex-end;
    background-color: ${(props) => props.theme.btnBlueColor};
  }

  .handle {
    width: 2.2rem;
    height: 2.2rem;
    background-color: white;
    border-radius: 40px;
  }
`;
